export type PageItem = number | '...'

export function calculatePageCount(total: number, pageSize: number): number {
  const safeTotal = Math.max(0, Number(total) || 0)
  const safeSize = Math.max(1, Number(pageSize) || 10)
  return Math.max(1, Math.ceil(safeTotal / safeSize))
}

export function clampPage(page: number, totalPages: number): number {
  const safeTotalPages = Math.max(1, Number(totalPages) || 1)
  const safePage = Number(page) || 1
  return Math.min(Math.max(1, safePage), safeTotalPages)
}

export function generatePageItems(current: number, totalPages: number): PageItem[] {
  const total = Math.max(1, Number(totalPages) || 1)
  const page = clampPage(current, total)

  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1)
  }

  if (page <= 4) {
    return [1, 2, 3, 4, 5, '...', total]
  }

  if (page >= total - 3) {
    return [1, '...', total - 4, total - 3, total - 2, total - 1, total]
  }

  return [1, '...', page - 1, page, page + 1, '...', total]
}
